// Glassbox custom-event reporting. Unrelated to analytics (Firehose) — extracted
// verbatim from the former pinpointConfig.js during the Firehose migration.
export const updateGlassboxUserAttributes = async (patientId) => {
  const eventName = "LandingPage";
  let glassboxData = {
    sessionId: window._detector.sessionId,
    visitorId: window._detector.visitorId,
    message: eventName,
    userId: patientId,
  };
  if (window._detector) {
    window._detector.triggerCustomEventMap(eventName, glassboxData);
  }
};
